module.exports = __webpack_public_path__ + "img/bubble.7bf563fe.jpg";